export default class DataService {

    public size(collection: any[] | object) {
        let count = 0;
        if ( collection instanceof Array ) {
            count = collection.length;
        } else if ( collection instanceof Object ) {
            let key;
            for (key in collection) {
                if (collection.hasOwnProperty(key)) {
                    count++;
                }
            }
        }

        return count;
    }

    public isNumeric(val: any) {
        return (!isNaN(parseFloat(val)) && isFinite(val));
    }

    public search(collection: any[], searchString: string, keys?: any[]) {
        let collectionIsArray: boolean;
        const newCollection: any[] = [];

        collectionIsArray = (collection instanceof Array);

        if ( !collectionIsArray ) {
            console.error('The collection is not a valid array');
            return;
        }

        collection.map((row: any, index: number) => {
            if ( row instanceof Object ) {

                if ( keys ) {
                    let isFound: boolean = false;
                    keys.map((key: string) => {
                        if ( isFound ) {
                            return;
                        }
                        
                        if ( row[key] && String(row[key]).toLowerCase().indexOf(String(searchString).toLowerCase()) > -1 ) {
                            newCollection.push(row);
                            isFound = true;
                        }
                    });
                }
            }
        });

        return newCollection;

    }
    
    public sort(collection: any[], keys: object, reverse: boolean = false, primer?: any) {
        const self = this;

        if ( collection instanceof Array ) {
            keys = keys || {};
            
            const obLen = (obj: object) => {
                let size = 0;
                let key;
                for (key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        size++;
                    }
                }
                return size;
            };

            // avoiding using Object.keys because i guess did it have IE8 issues?
            // else let obIx = fucntion(obj, ix){ return Object.keys(obj)[ix]; } or
            // whatever
            const obIx = (obj: object, ix: any) => {
                let size = 0;
                let key;
                for (key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        if (size === ix) {
                            return key;
                        }
                        size++;
                    }
                }
                return false;
            };

            const keySort = (a: any = null, b: any = null, d: any = null) => {
                let originalA;
                let originalB;
                
                d = d !== null ? d : 1;
                
                a = (typeof a !== 'undefined') ? ( self.isNumeric(a) || a === null) ? a : a.toLowerCase() : '';
                b = (typeof b !== 'undefined') ? ( self.isNumeric(b) || b === null) ? b : b.toLowerCase() : '';
                originalA = a;
                originalB = b;

                //
                // Handle special sorting scenarios
                // 0.00 should be a larger number than empty strings
                // Empty strings should be a larger number than '- -'
                switch (a) {
                    case '0.00' :
                        a = 0.00;
                        break;

                    case '' :
                        a = (self.isNumeric(originalB)) ? -1000000000 : ' ';
                        break;

                    case '- -' :
                        a = (self.isNumeric(originalB)) ? -10000000000 : '';
                        break;

                    default :
                        a = a;
                        break;
                }

                switch (b) {
                    case '0.00' :
                        b = 0.00;
                        break;

                    case '' :
                        b = (self.isNumeric(originalA)) ? -1000000000 : ' ';
                        break;

                    case '- -' :
                        b = (self.isNumeric(originalA)) ? -10000000000 : '';
                        break;

                    default :
                        a = a;
                        break;
                }

                //
                // value is number/float
                if ( !isNaN(parseFloat(a)) && isFinite(a) ) {
                    return d === 1 ? a - b : b - a;
                //
                // value is string
                } else {
                    return a > b ? 1 * d : a < b ? -1 * d : 0;
                }
            };

            const KL = obLen(keys);

            if (!KL) {
                return collection.sort(keySort);
            }

            for ( const k in keys) {
                // asc unless desc or skip
                if ( keys[k] ) {
                    keys[k] = (keys[k] === 'desc' || keys[k] === -1)  ? -1 : 
                            (keys[k] === 'skip' || keys[k] === 0 ? 0 : 1);
                }
            }

            collection.sort((a: any, b: any) => {
                let sorted = 0;
                let ix = 0;

                while (sorted === 0 && ix < KL) {
                    const k = obIx(keys, ix);
                    if (k) {
                        const dir = keys[k];
                        sorted = keySort(a[k], b[k], dir);
                        ix++;
                    }
                }
                return sorted;
            });

            return collection;
        }

        return [];
    }
}


// WEBPACK FOOTER //
// ./src/Services/Data/DataService.tsx